import { render, staticRenderFns } from "./tasting_info_card.vue?vue&type=template&id=88210f32&scoped=true"
import script from "./tasting_info_card.vue?vue&type=script&lang=js"
export * from "./tasting_info_card.vue?vue&type=script&lang=js"
import style0 from "./tasting_info_card.vue?vue&type=style&index=0&id=88210f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88210f32",
  null
  
)

export default component.exports